import * as React from 'react';
import { CreateButton } from '@ixicare/ui';
import { useNavigate } from 'react-router-dom';

const ResidentCreateContainer: React.FC = () => {
  const navigate = useNavigate();
  return <CreateButton atBottom onClick={() => navigate('/residents/create')} />;
};
export default ResidentCreateContainer;
